export default __webpack_public_path__ + "static/media/PortraitSelect.7326f834.svg";